/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      // Verhindere das Standard-Formular-Submit für manuelle Sprachauswahl
      const manualSelect = this.form.querySelector('#manual-language');
      if (manualSelect && manualSelect.value.includes('-man')) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

// Warte bis der DOM vollständig geladen ist
function initManualLanguageSwitcher() {
  // Finde alle manuellen Sprachauswahl-Dropdowns
  const manualLanguageSelects = document.querySelectorAll('[id^="manual-language-"]');
  
  manualLanguageSelects.forEach(manualLanguageSelect => {
    // Verhindere das Standard-Formular-Submit
    const form = manualLanguageSelect.closest('form');
    if (form) {
      // Event Listener für Änderungen im Dropdown
      manualLanguageSelect.addEventListener('change', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        const selectedValue = this.value;
        let targetDomain = '';
        
        // Bestimme die Ziel-Domain basierend auf der Auswahl
        switch(selectedValue) {
          case 'nl-man':
            targetDomain = 'https://casuallads.nl';
            break;
          case 'de-man':
            targetDomain = 'https://casuallads.de';
            break;
          case 'en-man':
            targetDomain = 'https://casuallads.com';
            break;
          default:
            return; // Keine gültige Auswahl
        }
        
        // Weiterleitung zur entsprechenden Domain mit aktuellem Pfad
        if (targetDomain) {
          const currentPath = window.location.pathname;
          const targetUrl = targetDomain + currentPath;
          window.location.href = targetUrl;
        }
      });
      
      // Verhindere auch das Formular-Submit
      form.addEventListener('submit', function(event) {
        const manualSelect = this.querySelector('[id^="manual-language-"]');
        if (manualSelect && manualSelect.value.includes('-man')) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      });
    }
  });
}

// Mehrfache Initialisierung für verschiedene DOM-Lade-Zustände
document.addEventListener('DOMContentLoaded', initManualLanguageSwitcher);
document.addEventListener('load', initManualLanguageSwitcher);

// Fallback: Versuche es nach einer kurzen Verzögerung
setTimeout(initManualLanguageSwitcher, 1000);
setTimeout(initManualLanguageSwitcher, 2000);
setTimeout(initManualLanguageSwitcher, 3000);